import { Injectable } from '@angular/core';
import { ProductReservation } from '@vestiaire/api-sdk-angular';

@Injectable()
export class ReservationService {
  isValid(reservation: ProductReservation) {
    return reservation.active && !this.isExpired(reservation);
  }

  isExpired(reservation: ProductReservation) {
    if (reservation.expirationDate) {
      return new Date(reservation.expirationDate) < new Date();
    }
    return false;
  }
}
